import { render, staticRenderFns } from "./MoodleCourseDashboard.vue?vue&type=template&id=2d6c1673"
import script from "./MoodleCourseDashboard.vue?vue&type=script&lang=js"
export * from "./MoodleCourseDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports